<script>
	export default {
		name: "LeafletMapSearchMarker",
		props: {
			map: {
				type: Object,
				required: true
			},
			leaflet: {
				type: Object,
				required: true
			},
			location: {
				type: Object,
			},
			loading: {
				type: Boolean,
			}
		},
		watch: {
			location(value) {
				if (value && value.latLng) {
					if (!this._marker) {
						this._marker = this.leaflet.marker([0, 0], {
							icon: this.leaflet.divIcon({className: 'is-hidden-print location-marker loading'}),
							interactive: false
						});
					}
					if (!this.map.hasLayer(this._marker))
						this._marker.addTo(this.map);

					this._marker.setLatLng(value.latLng);
				} else if (this._marker) {
					this._marker.remove(this.map);
				}
			},
			loading(value) {
				if (this._marker && this._marker._icon) {
					if(!value)
						this.leaflet.DomUtil.removeClass(this._marker._icon, 'loading');
                    else
						this.leaflet.DomUtil.addClass(this._marker._icon, 'loading');
				}
			}
		},
		render() {
			return this.$slots.default;
		},
	}
</script>

<style>
    .location-marker {
        background: url(../../../assets/svg/location-marker.svg);
        width: 28.5px !important;
        height: 45px !important;
        top: -36px !important;
        left: -14px !important;
        margin: 0 !important;
    }

    .location-marker.loading {
        background: url(../../../assets/svg/location-marker-loading.svg);
    }
</style>